//******************Exchange Rate Server Calls******************;

import { ApplicantsStatusFieldActions } from "./ApplicantsStatusFieldConstants";
import store from "../../../Store/store";
import { ROOT_URL,getCookie } from "../../../Config/Config";
import { failure_messages } from "Messages";

export const ApplicantsStatusFieldServer = {
  getApplicantsStatusField: getApplicantsStatusField
};

//******************Get ApplicantsStatusFields******************;

function getApplicantsStatusField(data) {
  const res = fetch(ROOT_URL + "/api/status/getAllStatuses", {
    method: "POST",
    mode: "cors",
    headers: { 
      'authorization':getCookie("admin_token_partner"),
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body:JSON.stringify(data)
  })
    .then(res => {
      res
        .json()
        .then(response => {
          if(response.status == "200")
          store.dispatch({
            type: ApplicantsStatusFieldActions.ApplicantsStatusField_Get.SUCCESS,
            payload: response.data
          })
          else
          store.dispatch({
            type: ApplicantsStatusFieldActions.ApplicantsStatusField_Get.FAILED,
            error: response.error
          })
        })
        
    })
    .catch(err => {
      console.log("ApplicantsStatusFieldError:", err);
      store.dispatch({
        type: ApplicantsStatusFieldActions.ApplicantsStatusField_Get.FAILED,
        error:failure_messages.StatusGetError
      });
    });

  return { type: ApplicantsStatusFieldActions.ApplicantsStatusField_Get.LOADING };
}
